import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { MessageCircle, Instagram, Mail, BarChart3, Bell, Shield, Check, ArrowRight } from "lucide-react";

const PersonalAssistantPage = () => {
  const features = [
    {
      icon: MessageCircle,
      title: "WhatsApp Asistanı",
      desc: "WhatsApp mesajlarınızı okuyan, önemli olanları özetleyen ve sizin adınıza yanıt taslakları hazırlayan akıllı asistan. Grup mesajlarını filtreler, önceliklendirir.",
    },
    {
      icon: Instagram,
      title: "Instagram Yönetimi",
      desc: "DM'leri kategorilere ayırır, müşteri sorularını yanıtlar, yorumları analiz eder ve haftalık etkileşim raporu hazırlar.",
    },
    {
      icon: Mail,
      title: "E-posta Kontrol & Raporlama",
      desc: "Gelen kutunuzu tarar, öncelikli e-postaları ayırır, spam'i filtreler. Günlük/saatlik özet raporu hazırlar. Toplantı davetlerini takviminize ekler.",
    },
    {
      icon: BarChart3,
      title: "Akıllı Raporlama",
      desc: "Tüm kanallardan gelen mesaj, etkileşim ve bildirimleri tek bir dashboard'da birleştirir. Haftalık trend analizi ve zaman yönetimi önerileri sunar.",
    },
    {
      icon: Bell,
      title: "Akıllı Bildirim",
      desc: "Sadece gerçekten önemli olanları size iletir. Toplantı hatırlatmaları, son teslim tarihleri ve acil mesajlar için özelleştirilebilir uyarı sistemi.",
    },
    {
      icon: Shield,
      title: "Gizlilik Odaklı",
      desc: "Tüm verileriniz uçtan uca şifrelenir. Mesaj içerikleriniz hiçbir şekilde üçüncü taraflarla paylaşılmaz veya eğitim amaçlı kullanılmaz.",
    },
  ];

  const hero = (
    <PageHero
      eyebrow="Ürün"
      title="Kişisel AI Asistan"
      subtitle="WhatsApp, Instagram ve e-postalarınızı tek merkezden yöneten, önemli olanları filtreleyip size özetleyen yapay zeka asistanınız."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/social-media.jpg" alt="Sosyal medya asistanı" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Dijital hayatınızı düzene sokun</h2>
            <p className="text-[15px] leading-relaxed max-w-2xl mx-auto" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Her gün onlarca WhatsApp mesajı, Instagram DM'i ve e-posta arasında kaybolmayın. Kişisel AI asistanınız sizin için filtrelesin, özetlesin ve önceliklendirsin.
            </p>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((f) => (
                <div key={f.title} className="p-6 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <f.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{f.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{f.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-12 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/whatsapp-phone.jpg"
                alt="WhatsApp mobil asistan"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "340px" }}
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[24px] font-bold mb-4" style={{ color: "var(--fg)" }}>Günde 2 saat kazanın</h2>
            <p className="text-[15px] mb-8" style={{ color: "var(--fg)", opacity: 0.82 }}>
              Ortalama bir kullanıcı, mesajlaşma ve e-posta yönetiminde günde 2 saatini kurtarıyor. Siz de zamandan tasarruf edin, önemli işlere odaklanın.
            </p>
            <a href="https://app.verasist.ai" className="inline-flex items-center gap-2 px-10 py-4 rounded-full font-bold text-[15px] transition-all duration-200" style={{ background: "var(--brand-navy)", color: "#fff" }}>
              Hemen Başlayın <ArrowRight size={18} />
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default PersonalAssistantPage;
